import React from "react";
import { Stack, Stepper, Step, StepLabel, Card, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import {
  Send,
  Email,
  CheckCircleOutline,
  CancelOutlined,
} from "@mui/icons-material";
import StepperProps from "./StepperProps";

import ImageSWF1 from "assets/images/StepWorkflow/SWF1.png";
import ImageSWF2 from "assets/images/StepWorkflow/SWF2.png";
import ImageSWF3 from "assets/images/StepWorkflow/SWF3.png";
import ImageSWF4 from "assets/images/StepWorkflow/SWF4.png";


export default function StepperProject(props: StepperProps) {
  
  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 31,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          "linear-gradient( 329deg, rgb(255 211 131) 0%, rgb(241 150 52) 50%, rgb(255 198 118) 100%)",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          "linear-gradient( 331deg, rgb(127 215 71) 0%, rgb(23 159 54) 50%, rgb(136 221 135) 100%)",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      paddingTop: 2,
      marginTop: 43,
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
      borderRadius: 1,
    },
  }));

  const ColorlibStepIconRoot = styled("div")<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 70,
    height: 70,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    border: '5px solid #ececec',
    ...(ownerState.active && {
      backgroundImage:
        "linear-gradient( 329deg, rgb(255 211 131) 0%, rgb(241 150 52) 50%, rgb(255 198 118) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
      border: '5px solid #ffe9c6',
    }),
    ...(ownerState.completed && {
      backgroundImage:
        "linear-gradient( 331deg, rgb(127 215 71) 0%, rgb(23 159 54) 50%, rgb(136 221 135) 100%)",
        border: '5px solid #c5ffd7',
    }),
  }));

  const ColorlibStepIcon = (prop: StepIconProps) => {
    const { active, completed, className } = prop;

    const icons: { [index: string]: React.ReactElement } = {
      1:
        <img
          src={ImageSWF1}
          alt={''}
          style={{
              width: '60%',
              minHeight: "50%",
              height: "60%",
          }}
        />,
      2:
        <img
          src={ImageSWF2}
          alt={''}
          style={{
            width: '60%',
            minHeight: "50%",
            height: "60%",
          }}
        />,
      3:
        <img
          src={ImageSWF3}
          alt={''}
          style={{
            width: '60%',
            minHeight: "50%",
            height: "60%",
          }}
        />,
      4:
        <img
          src={ImageSWF4}
          alt={''}
          style={{
            width: '60%',
            minHeight: "50%",
            height: "60%",
          }}
        />,
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}          
      >
        {icons[String(prop.icon)]}
      </ColorlibStepIconRoot>
    );
  };

  return (
    <Grid item xs={12} md={12} container spacing={1}>
      {/* <Card
        sx={{
          minHeight: 130,
          borderRadius: "20px",
          marginTop: 1,
        }}
      > */}
        <Grid item container xs={12} md={12} spacing={1} justifyContent={"start"}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Stepper
              alternativeLabel
              activeStep={props.nActiveStep}
              connector={<ColorlibConnector />}
            >
              {props.arrStepper.map((item, index) => (
                <Step key={item.sLabel}>
                  <div
                    style={{
                      textAlign: "center",
                      height: "25px",
                      fontSize: "14px",
                    }}
                    // style={{
                    //   borderRadius: '50%',
                    //   width: '85px',
                    //   height: '85px',
                    //   justifyContent: 'center',
                    //   alignItems: 'center',
                    //   backgroundImage: 'linear-gradient( 331deg, rgb(153 255 161) 0%, rgb(255 255 255) 50%, rgb(142 255 141) 100%)',
                    // }}
                  >
                    {item.sActionBy}
                  </div>
                  <StepLabel
                    sx={{ paddingTop: 2 }}
                    StepIconComponent={ColorlibStepIcon}
                  >
                    {item.sLabel}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
        </Grid>
      {/* </Card> */}
    </Grid>
  );
}
